// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-type-switching-tab-container {
    width: fit-content;
    margin-left: 50%;
    margin-bottom: 2rem;
    transform: translateX(-50%);
}

.search-type-switching-tab {
    font-size: 1rem;
}

@media (max-width: 992px) {
    .search-type-switching-tab-container {
        margin-bottom: 0;
    }
}

@media (max-width: 700px) {
    .search-type-switching-tab-container {
        margin-bottom: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/advancedSearch/SearchTypeSwitchingTabs.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".search-type-switching-tab-container {\n    width: fit-content;\n    margin-left: 50%;\n    margin-bottom: 2rem;\n    transform: translateX(-50%);\n}\n\n.search-type-switching-tab {\n    font-size: 1rem;\n}\n\n@media (max-width: 992px) {\n    .search-type-switching-tab-container {\n        margin-bottom: 0;\n    }\n}\n\n@media (max-width: 700px) {\n    .search-type-switching-tab-container {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
